import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/ui-common/src/FileValidationErrorsPopup/FileValidationErrorsPopup.styled.ts",
    _templateObject2,
    _templateObject3,
    _templateObject4,
    _templateObject5,
    _templateObject6;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
import { RoundedCross as RoundedCrossInit } from '../icons';
export var Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 16px 24px;\n"])));
export var Header = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n"])));
export var Title = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 18px;\n  line-height: 21px;\n  color: #000335;\n  letter-spacing: 0.1px;\n"])));
export var RoundedCross = styled(RoundedCrossInit)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  cursor: pointer;\n\n  path {\n    fill: #353b60;\n  }\n"])));
export var ErrorsWrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-top: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  max-height: 500px;\n  overflow-y: auto;\n"])));
export var ErrorMessage = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  color: #000335;\n"])));